import {ADataGridFilter} from '@atiautomacao/ati-ui-library';
import {
    PowerStationCommunicationState,
    PowerStationPerformanceRow,
} from './PerformanceAnalysisReducer';

const isActiveSort = (sort: string | undefined): boolean => sort === 'asc' || sort === 'desc';

const COMMUNICATION_RANK_ASC: Record<PowerStationCommunicationState, number> = {
    NO_COMMUNICATION: 0,
    COMMUNICATING: 1,
    SYNCHRONIZING: 2,
};

const COMMUNICATION_RANK_DESC: Record<PowerStationCommunicationState, number> = {
    SYNCHRONIZING: 0,
    COMMUNICATING: 1,
    NO_COMMUNICATION: 2,
};

export function getActiveCommunicationSortDirection(
    filters: ADataGridFilter[]
): 'asc' | 'desc' | null {
    const communicationFilter = normalizePerformanceAnalysisSortFilters(filters)
        .find((filter) => filter.name === 'communicationState');
    const sort = communicationFilter?.sort;
    return sort === 'asc' || sort === 'desc' ? sort : null;
}

export function sortPowerStationPerformanceRows(
    rows: PowerStationPerformanceRow[],
    direction: 'asc' | 'desc'
): PowerStationPerformanceRow[] {
    const rankByState = direction === 'desc' ? COMMUNICATION_RANK_DESC : COMMUNICATION_RANK_ASC;
    return [...rows].sort((first, second) => {
        const byCommunication = rankByState[first.communicationState] - rankByState[second.communicationState];
        if (byCommunication !== 0) {
            return byCommunication;
        }
        return first.powerStationName.localeCompare(second.powerStationName, 'pt-BR');
    });
}

export function normalizePerformanceAnalysisSortFilters(
    filters: ADataGridFilter[]
): ADataGridFilter[] {
    const communicationSorted = filters.some(
        (filter) => filter.name === 'communicationState' && isActiveSort(filter.sort)
    );
    const anotherColumnSorted = filters.some(
        (filter) =>
            filter.name !== 'communicationState'
            && filter.name !== 'performanceRatio'
            && isActiveSort(filter.sort)
    );

    return filters.map((filter) => {
        if (communicationSorted && filter.name !== 'communicationState') {
            return {...filter, sort: 'none'};
        }

        if (filter.name === 'communicationState') {
            return {
                ...filter,
                sort: isActiveSort(filter.sort) ? filter.sort : 'none',
            };
        }

        if (filter.name === 'performanceRatio') {
            if (anotherColumnSorted) {
                return {...filter, sort: 'none'};
            }
            return {
                ...filter,
                sort: isActiveSort(filter.sort) ? filter.sort : 'desc',
            };
        }

        return {...filter};
    });
}
